<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    overlay-opacity="0.9"
    @click:outside="close"
    :persistent="loading"
  >
    <v-card v-if="!!ticket && !succeeded">
      <v-card-title class="headline" v-if="!transferDisabled">
        Transferir Ingresso
      </v-card-title>
      <v-card-text class="pb-2">
        <template v-if="transferDisabled">
          <div class="text-center pt-8">
            <v-avatar class="mb-4" size="60" color="grey lighten-4">
              <v-icon x-large color="grey darken-2">
                {{ transferDisabled.icon }}
              </v-icon>
            </v-avatar>
            <h6>{{ transferDisabled.text }}</h6>
          </div>
        </template>
        <template v-else>
          <phone-input
            :phone="whatsapp"
            @update:phone="(e) => (whatsapp = e)"
            :ddi="ddi"
            @update:ddi="(e) => (ddi = e)"
            @valid="(v) => (valid = v)"
            dense
            outlined
            label="WhatsApp do Destinatário"
            :disabled="loading"
          />
          <v-checkbox
            class="my-0 pt-0"
            v-model="check"
            :disabled="loading"
            label="Confirmo que o WhatsApp do destinatário está correto."
            :rules="[(v) => !!v || 'Confirmação é obrigatória']"
          />
          <v-alert v-if="ticket?.TicketEntry?.lenght" type="warning" dense text>
            Esse ingresso já foi utilizado para entrar no evento.
          </v-alert>
          <v-alert
            v-if="
              ticket?.RefoundRequest?.lenght &&
              !ticket?.RefoundRequest[0]?.closedAt
            "
            type="warning"
            dense
            text
          >
            Esse ingresso possui uma solicitação de reembolso pendente.
          </v-alert>

          <v-alert type="error" v-if="error" class="mt-2 mb-0" border="left">
            {{ error }}
          </v-alert>
        </template>
      </v-card-text>
      <v-card-actions class="d-flex flex-column">
        <v-btn
          v-if="!transferDisabled"
          color="primary"
          @click="transfer"
          block
          :disabled="!valid || !check"
          :loading="loading"
          class="mb-2"
        >
          Transferir
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
          :disabled="loading"
          block
          class="ml-0"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="succeeded">
      <v-card-text>
        <div class="text-center pt-8">
          <v-avatar class="mb-4" size="60" color="success lighten-4">
            <v-icon x-large color="success darken-2">mdi-check</v-icon>
          </v-avatar>
          <h6>Ingresso transferido com sucesso!</h6>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex flex-column">
        <v-btn color="primary" text @click="close(true)" block class="ml-0">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import SUPPORT from "@/services/support";
import { mapGetters } from "vuex";
import PhoneInput from "../../global/PhoneInput.vue";
export default {
  components: { PhoneInput },
  props: {
    data: Object,
  },
  data: () => ({
    dialog: false,
    ticket: null,
    party: null,
    loading: false,
    valid: false,
    error: false,
    whatsapp: "",
    ddi: 55,
    check: false,
    succeeded: false,
  }),
  methods: {
    async transfer() {
      try {
        this.loading = true;
        this.error = false;
        await SUPPORT.transferTicket(this.ticket.id, {
          ownerId: this.data.user.id,
          user: { phone: this.whatsapp, ddi: this.ddi },
        });
        this.succeeded = true;
        this.loading = false;
      } catch (error) {
        this.error = error.message || "Erro ao transferir ingresso";
        this.check = false;
        this.loading = false;
      }
    },
    open(data) {
      this.ticket = data.ticket;
      this.party = data.party;
      this.succeeded = false;
      this.error = false;
      this.dialog = true;
    },
    close(success = false) {
      if (this.loading) return;
      this.dialog = false;
      if (success) this.$emit("success");
      this.$nextTick(() => {
        this.whatsapp = "";
        this.ddi = 55;
        this.check = false;
        this.error = false;
        this.succeeded = false;
      });
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    transferDisabled() {
      if (!this.ticket) return { icon: "mdi-error", text: "Erro ao carregar" };

      const partyDate = this.party?.endDate || this.party?.date;
      if (moment(partyDate).isBefore(moment()))
        return {
          icon: "mdi-ticket",
          text: "Não é possível transferir ingressos após o evento",
        };

      return false;
    },
  },
  watch: {
    whatsapp() {
      this.error = false;
    },
  },
  mounted() {
    this.$root.$on("transfer-ticket", this.open);
  },
};
</script>

<style></style>
